import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { supabase } from "../../../supabase";
import { login, setSessionUser } from "../../Reducers/actions/authActions";
import { validateEmail, validateUsername } from "../../../helpers/utilities";
// import Separator from "../../components/Separator/Separator";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../components/Icon/Icon";
import HykLogo from "../../components/Icon/HykLogo";
import { LATEST_ONBOARDING_VERSION, AUTH_ERRORS } from "../../constants/globals"; 
import { startGoogleAuth } from "./googleAuth";
import GoogleButtonContent from "./GoogleButtonContent";
import "./AuthCommLink.scss";
export default function Login() {
    const session = useSelector((state) => state.auth?.session);
    const OnBoardingVersion = useSelector((state) => state.auth?.user?.onboarding_version)

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(true);
    const [loadingLogin, setLoadingLogin] = useState(false)
    const [loadingGoogle, setLoadingGoogle] = useState(false)
    const [showPwd, setShowPwd] = useState(false)
    // const [toastMessage, setToastMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);
    const [error, setError] = useState(null)
    const [animated, setAnimated] = useState(false)
    const [finishAnimation, setFinishAnimation] = useState(false)
    const dispatch = useDispatch()
    // const [toastType, setToastType] = useState("toast-info");
    const navigate = useNavigate();

    // Disabled keyboard detection due to Safari iOS issues
    const keyboardVisible = false;

    //  // Handle keyboard open/close for mobile scrolling
    // useEffect(() => {
    //     if (keyboardVisible) {
    //         document.body.classList.add('keyboard-open');
    //         // Scroll to focused input when keyboard opens
    //         const focusedElement = document.querySelector(':focus');
    //         if (focusedElement) {
    //             setTimeout(() => {
    //                 focusedElement.scrollIntoView({
    //                     behavior: 'smooth',
    //                     block: 'center'
    //                 });
    //             }, 300);
    //         }
    //     } else {
    //         document.body.classList.remove('keyboard-open');
    //     }

    //     return () => {
    //         document.body.classList.remove('keyboard-open');
    //     };
    // }, [keyboardVisible]);

    // useEffect(() => {
    //     if (session && session.user) {
    //         navigate("/profile")
    //     }
    // }, [session, navigate])

    useEffect(() => {
        const checkUser = async () => {
            setLoading(true)
            const { data } = await supabase.auth.getSession();
            if (data.session && data.session) {
                dispatch(setSessionUser(data.session));
                if (OnBoardingVersion == LATEST_ONBOARDING_VERSION) { navigate("/on-boarding") }
                else navigate("/");
            } else {
                setLoading(false)
            }
        };
        checkUser();
    }, [navigate]);

    const validateForm = useCallback(() => {
        // const newErrors = {};
        const BreakException = {}
        try {
            if (!(email && email.length > 0 && (validateEmail(email) || validateUsername(email)))) {
                setErrorMessage("Email or username is required.")
                throw BreakException
            }

            if (!(password && password.length > 0)) {
                setErrorMessage("Password is required.")
                throw BreakException
            }

            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/
            if (password && !passwordRegex.test(password)) {
                setErrorMessage("Password must be at least 8 characters long, with at least 1 uppercase, 1 lowercase, and 1 special character.")
                throw BreakException
            }

            setErrorMessage(null)
        } catch (e) {
            if (e !== BreakException) console.log(e)
        }
    }, [email, password]);

    useEffect(() => {
        setError(null)
        validateForm()
    }, [email, password, validateForm])

    // Monitor for auto-fill changes
    useEffect(() => {
    }, []); // Only run once on mount
    // const showToast = (message, type = "toast-info") => {
    //     setToastMessage(message);
    //     setToastType(type);
    //     setTimeout(() => setToastMessage(""), 3000);
    // };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoadingLogin(true);
        login({ email, password }).then(async ({ success, data, message }) => {
            if (success && data && data.session) {
                // Validate tokens exist before setting session
                if (!data.session.access_token || !data.session.refresh_token) {
                    setLoadingLogin(false);
                    setError(AUTH_ERRORS.INVALID_SESSION);
                    return;
                }

                // Set session on client-side Supabase (syncs with server auth)
                const { error: sessionError } = await supabase.auth.setSession({
                    access_token: data.session.access_token,
                    refresh_token: data.session.refresh_token,
                });

                if (sessionError) {
                    console.error('Failed to set session:', sessionError);
                    setLoadingLogin(false);
                    setError(AUTH_ERRORS.AUTH_FAILED);
                    return;
                }

                // Session set successfully, update Redux
                dispatch(setSessionUser(data.session));
                setLoadingLogin(false);

                // Navigation logic
                if (data?.user?.last_sign_in_at) {
                    if (data?.user?.onboarding_version == LATEST_ONBOARDING_VERSION) navigate("/on-boarding")
                    else navigate("/")
                }
                else navigate('/add-social-links')
            } else {
                setLoadingLogin(false);
                setError(message)
            }

        })
    };

    const handleGoogleLogin = async () => {
        setError(null);
        setLoadingGoogle(true);
        const result = await startGoogleAuth("/");
        if (!result.success) {
            setError(result.message);
            setLoadingGoogle(false);
            return;
        }
        window.location.href = result.url;
    };

    const isGoogleAuthEnabled = import.meta.env.VITE_ENABLE_GOOGLE_AUTH !== "false";

    useEffect(() => {
        if (!loading && !session) {
            setTimeout(() => {
                setAnimated(true)
                setTimeout(() => {
                    setFinishAnimation(true)
                }, 1000)
            }, 1000)
        }
    }, [loading, session]);

    // async function signInWithGoogle() {
    //     const { data, error } = await supabase.auth.signInWithOAuth({
    //         provider: "google",
    //         options: {
    //             redirectTo: window.location.origin, // Redirect to current site after login
    //         },
    //     });

    //     if (error) {
    //         console.error("Google Sign-In Error:", error.message);
    //     } else {
    //         console.log("Google Sign-In Success:", data);
    //     }
    // }

    return (
        session ? OnBoardingVersion == LATEST_ONBOARDING_VERSION ? <Navigate to="/on-boarding" /> : <Navigate to="/" /> :
            <div className="px-16 pt-16 login-container bg-red">
                {!finishAnimation && <div className={`first-screen ${finishAnimation ? "finish-animation" : ""}`}>
                    <HykLogo
                        width={120}
                        height={120}
                        className={`${animated ? "image-expand" : ""}`}
                        color="#FF3232"
                    />
                    {/* <Icon alias="hyk_logo" className={`${animated ? "image-expand" : ""}`} width={120} color="#FF3232" /> */}
                </div>}

                {finishAnimation && <div className="d-flex aic jcfs bg-red f-column p-fixed" style={{ height: '100%', top: 0, left: 0 }}>
                    {!keyboardVisible && <div className="d-flex aic jcc my-40 pb-24">
                        <Icon alias={"hyk"} width={48} color="#FFF" className="hyk-icon-animate" />
                    </div>}
                    <div className={`auth-container login-animated-container px-16 animate-slide-up`}>
                        {/* <img src="hyk_logo.png" width={106} height={106} alt="hyk_logo" /> */}
                        <p className="fs-md2 fw-bold mb-40 mt-0">WELCOME TO HYK</p>
                        {error && <p className="error-message">{error}</p>}
                        <form onSubmit={handleLogin} className="auth-form">
                            <input
                                ref={(el) => {
                                    if (el) {
                                        // Check for auto-filled values on mount and after auto-fill
                                        const checkAutoFill = () => {
                                            if (el.value && el.value !== email) {
                                                setEmail(el.value);
                                            }
                                        };

                                        // Check immediately
                                        checkAutoFill();

                                        // Check after a delay to catch auto-fill
                                        setTimeout(checkAutoFill, 100);
                                        setTimeout(checkAutoFill, 500);
                                        setTimeout(checkAutoFill, 1000);
                                    }
                                }}
                                className="input-main"
                                placeholder="Email or username"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                onFocus={() => {
                                    // Force mobile keyboard to open - disabled for Safari iOS
                                    // e.target.click();
                                    // e.target.focus();
                                }}
                                onTouchStart={() => {
                                    // Ensure input is focused on touch - disabled for Safari iOS
                                    // e.target.focus();
                                }}
                                onInput={(e) => {
                                    // Catch auto-fill events
                                    if (e.target.value !== email) {
                                        setEmail(e.target.value);
                                    }
                                }}
                                type="text"
                                inputMode="text"
                                autoComplete="email"
                                autoCapitalize="none"
                                autoCorrect="off"
                                spellCheck="false"
                                required
                            />
                            <div className="p-relative">
                                <input
                                    ref={(el) => {
                                        if (el) {
                                            // Check for auto-filled values on mount and after auto-fill
                                            const checkAutoFill = () => {
                                                if (el.value && el.value !== password) {
                                                    setPassword(el.value);
                                                }
                                            };

                                            // Check immediately
                                            checkAutoFill();

                                            // Check after delays to catch auto-fill
                                            setTimeout(checkAutoFill, 100);
                                            setTimeout(checkAutoFill, 500);
                                            setTimeout(checkAutoFill, 1000);
                                        }
                                    }}
                                    className="input-main w-full mb-8"
                                    placeholder="Password"
                                    type={showPwd ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    onFocus={() => {
                                        // Force mobile keyboard to open - disabled for Safari iOS
                                        // e.target.click();
                                        // e.target.focus();
                                    }}

                                    onInput={(e) => {
                                        // Catch auto-fill events
                                        if (e.target.value !== password) {
                                            setPassword(e.target.value);
                                        }
                                    }}
                                    inputMode="text"
                                    autoComplete="current-password"
                                    autoCapitalize="none"
                                    autoCorrect="off"
                                    spellCheck="false"
                                    required
                                />
                                <Icon alias={"show-password"} width={24} color="#777777" className={'show-icon'} onClick={() => setShowPwd(prev => !prev)} />
                            </div>
                            {/* <p className="link-btn mb-16 mt-0" onClick={() => navigate("/send-recover")}>I forgot my password</p> */}
                            <button type="submit" className="btn red-btn btn-full-v" disabled={loadingLogin || loadingGoogle || !!errorMessage}>{loadingLogin ? "Logging in..." : "Login"}</button>
                            {isGoogleAuthEnabled && (
                                <button
                                    type="button"
                                    className="btn btn-full-v mt-16 google-auth-btn"
                                    onClick={handleGoogleLogin}
                                    disabled={loadingLogin || loadingGoogle}
                                    aria-label="Continue with Google"
                                >
                                    <GoogleButtonContent loading={loadingGoogle} />
                                </button>
                            )}
                            {/* <p className="fs-xxs fg-crea fw-medium ta-center mt-8 mb-0">OR CONTINUE WITH</p> */}
                        </form>
                        {/* <div className="social-group">
                    <button onClick={signInWithGoogle} className="btn red-outline-btn btn-full-v fs-xs mt-24">
                        <img src="google.png" className={"icon"} width={18} height={18} alt="google" />
                        Google
                    </button>
                    <button onClick={signInWithGoogle} className="btn white-btn btn-full-v fs-xs mt-24">
                        <img src="facebook.png" className={"icon"} width={18} height={18} alt="facebook" />
                        Sign up with Facebook
                    </button>
                </div> */}
                        <p className="auth-text mb-0 fg-crea fw-medium mt-24">Have you forgotten your password ? </p>
                        <p className="link-btn fg-red-pink fw-bold mt-0" onClick={() => navigate("/send-recover")}>Recover password</p>
                        {/* {toastMessage && <div className={`toast ${toastType} toast-show`}>{toastMessage}</div>} */}
                    </div>
                </div>}
            </div>
    );
}
